<script setup>
import ContactFormVue from "@/components/HomeComponents/biz/ContactForm.vue";
import PresentationBlock from "@/components/HomeComponents/biz/Partials/PresentationBlock.vue";
</script>

<template>
  <div class="contact-page">
    <PresentationBlock>
      <div class="container">
        <div class="section__head section__head--center">
          <h2>Skontaktuj się z nami</h2>
          <p>W razie jakichkolwiek pytań, jesteśmy do Twojej dyspozycji.</p>
        </div>

        <div class="contact-form__content">
          <div class="contact-form__illustration">
            <img src="@/assets/illustrations/business/contact-support.svg" alt="Ilustracja kontaktu">
          </div>

          <div class="contact-form__card">
            <ContactFormVue />
          </div>
        </div>
      </div>
    </PresentationBlock>
  </div>
</template>

<style scoped lang="scss">
.contact-page .contact-form__content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  align-items: start;
}

.contact-page .contact-form__illustration img {
  width: 100%;
  height: auto;
  display: block;
}

.contact-page .contact-form__card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
  padding: 24px;
}

.contact-page {
  color: #1f2937;
}

.contact-page .container {
  width: min(1200px, calc(100% - 32px));
  margin: 0 auto;
}

.contact-page .section {
  position: relative;
  padding: 56px 0;
}

.contact-page .section__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 24px;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 12px;
}

.contact-page .section__head--center {
  flex-direction: column;
  justify-content: center;
  text-align: center;
}

.contact-page .section__head h2 {
  margin: 0;
  font-size: clamp(2.6rem, 2vw, 3.4rem);
  line-height: 1.15;
  color: #111827;
}

.contact-page .section__head p {
  margin: 0;
  color: #6b7280;
  max-width: 760px;
  font-size: 1.5rem;
  line-height: 1.55;
}

.contact-page .section__illustration {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.contact-page .section__illustration img {
  width: min(100%, 760px);
  height: auto;
  display: block;
}

@media (max-width: 1024px) {
  .contact-page .contact-form__content {
    grid-template-columns: 1fr;
  }

  .contact-page .contact-form__illustration {
    max-width: 680px;
    margin: 0 auto;
  }
}

@media (max-width: 720px) {
  .contact-page .contact-form__card {
    padding: 16px;
  }
}
</style>